module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/avatar-example-8-d8246f9203bb079ad6cbbf04333f2e4a.png";